import React, { useEffect, useState, useCallback } from 'react';
import "./OrderDetails.css";
import { ReactComponent as CloseIcon } from '../../../assets/icons/x-icon.svg';
import { ReactComponent as LayerIcon } from '../../../assets/icons/layers-icon.svg';
import { formatToReadableDate, getOrdersStatusColor } from '../../../utils/utils';
import { ordersService } from '../../../services/ordersService';
import { ReactComponent as DotIcon } from '../../../assets/icons/dot-icon.svg';
import LoadingAnimation from '../LoadingAnimation/LoadingAnimation';
import { parseApiError } from '../../../utils/parseErrorMessage';
import EditableCell from '../EditableCell';

const OrderDetails = ({ orderId, closeModal }) => {
    const [orderDetails, setOrderDetails] = useState({});
    const [sourceOrderId, setsourceOrderId] = useState(orderId);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [isOrderIdEdit, setIsOrderIdEdit] = useState(false);
    const [isOrderNameEdit, setIsOrderNameEdit] = useState(false);
    const [isReceivalDateEdit, setIsReceivalDateEdit] = useState(false);

    const [orderIdError, setOrderIdError] = useState(null);
    const [orderNameError, setOrderNameError] = useState(null);
    const [orderReceivalError, setOrderReceivalError] = useState(null);

    const fetchOrdersDetails = useCallback(async () => {
        setIsDataLoading(true)
        ordersService.getOrderDetails(sourceOrderId)
            .then(response => {
                console.log("ordersService.getOrderDetails response ", response)
                console.log("ordersService.getOrderDetails response receival_date ", response.receival_date)
                if (response) {
                    setOrderDetails(response);
                    setsourceOrderId(response.order_id)
                }
            })
            .catch(error => {
                console.log("ordersService.getData error ", error);
            })
            .finally(() => { setIsDataLoading(false) });
    }, [sourceOrderId]);

    useEffect(() => {
        fetchOrdersDetails();
    }, [fetchOrdersDetails]);


    const handleUpdate = (fieldName) => {
        setOrderIdError(null)
        setOrderNameError(null)
        setOrderReceivalError(null)
        setIsDataLoading(true);
        if (fieldName === "order_id") {
            ordersService.updateOrderDetailId(sourceOrderId, orderDetails.order_id)
                .then(response => {
                    console.log("ordersService.updateStatus ", response)
                    if (response.rows_updated) {
                        setsourceOrderId(orderDetails.order_id);
                    }
                })
                .catch(error => {
                    const errorMessage = parseApiError(error)
                    setOrderIdError(errorMessage)
                })
                .finally(() => {
                    setIsOrderIdEdit(false);
                    setIsDataLoading(false);
                })
        }
        if (fieldName === "order_name") {
            ordersService.updateOrderDetailName(sourceOrderId, orderDetails.order_name)
                .then(response => {
                    console.log("ordersService.updateStatus ", response)
                    if (response.rows_updated) {
                        setsourceOrderId(orderDetails.order_id);
                    }
                })
                .catch(error => {
                    const errorMessage = parseApiError(error)
                    setOrderNameError(errorMessage)
                })
                .finally(() => {
                    setIsDataLoading(false);
                    setIsOrderNameEdit(false);
                })
        }
        if (fieldName === "receival_date") {
            ordersService.updateOrderDetailReceivalDate(sourceOrderId, orderDetails.receival_date)
                .then(response => {
                    console.log("ordersService.updateStatus ", response)
                    if (response.rows_updated) {
                        setsourceOrderId(orderDetails.order_id);
                    }
                })
                .catch(error => {
                    const errorMessage = parseApiError(error)
                    setOrderReceivalError(errorMessage)
                })
                .finally(() => {
                    setIsDataLoading(false);
                    setIsReceivalDateEdit(false);
                })
        }
    }

    return (
        <div className="modal-overlay" onClick={() => closeModal()}>
            <div className="modal-container order-details-modal" style={{ maxWidth: "85%" }} onClick={(e) => e.stopPropagation()}>
                <div className="modal-header" style={{ borderBottom: "1px solid #E7E7E7", gap: "40px", paddingBottom: "20px", marginBottom: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <LayerIcon width={36} color='#637381' />
                        <h1>
                            Детали заказа
                        </h1>

                        <div className='order-details-status-container'>
                            <div className={`data-table-column`} style={{ color: getOrdersStatusColor(orderDetails?.status) }}>
                                {
                                    <DotIcon width={6} color={getOrdersStatusColor(orderDetails?.status)} />
                                }
                                {orderDetails?.status}
                            </div>
                        </div>

                    </div>

                    <button
                        onClick={closeModal}
                        className='modal-header-close-button'
                        onMouseEnter={(e) => (e.currentTarget.style.color = "#4b5563")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "#9ca3af")}
                    >
                        <CloseIcon size={24} />
                    </button>
                </div>

                <div className='modal-body'>
                    {isDataLoading && <LoadingAnimation />}
                    <div style={{ "display": "flex", "flexDirection": "row", "gap": 10, "justifyContent": "space-between" }}>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label htmlFor="orderId" style={{ fontSize: 14 }} className="form-label">Номер заказа</label>
                            <EditableCell
                                type="text"
                                value={orderDetails.order_id ?? ""}
                                isEditing={isOrderIdEdit}
                                onChange={(e) => setOrderDetails({ ...orderDetails, order_id: e.target.value })}
                                onEdit={() => setIsOrderIdEdit(true)}
                                onConfirm={() => handleUpdate("order_id")}
                                onCancel={() => { setIsOrderIdEdit(false); fetchOrdersDetails(); }}
                                variant="form"
                                displayContainerStyle={{fontSize: "16px"}}
                                // editingContainerStyle={{fontSize: "16px"}}
                            />
                            {orderIdError && <div className="form-error">{orderIdError}</div>}
                        </div>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label htmlFor="orderName" style={{ fontSize: 14 }} className="form-label">Название заказа</label>
                            <EditableCell
                                type="text"
                                value={orderDetails?.order_name ?? ""}
                                isEditing={isOrderNameEdit}
                                onChange={(e) => setOrderDetails({ ...orderDetails, order_name: e.target.value })}
                                onEdit={() => setIsOrderNameEdit(true)}
                                onConfirm={() => handleUpdate("order_name")}
                                onCancel={() => { setIsOrderNameEdit(false); fetchOrdersDetails(); }}
                                variant="form"
                                displayContainerStyle={{fontSize: "16px"}}
                            />
                            {orderNameError && <div className="form-error">{orderNameError}</div>}
                        </div>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label htmlFor="date" style={{ fontSize: 14 }} className="form-label">Планируемая дата получения</label>
                            <EditableCell
                                type="date"
                                value={orderDetails.receival_date ?? ""}
                                isEditing={isReceivalDateEdit}
                                onChange={(e) => setOrderDetails({ ...orderDetails, receival_date: e.target.value })}
                                onEdit={() => setIsReceivalDateEdit(true)}
                                onConfirm={() => handleUpdate("receival_date")}
                                onCancel={() => { setIsReceivalDateEdit(false); fetchOrdersDetails(); }}
                                renderValue={(v) => v ? formatToReadableDate(v) : ""}
                                variant="form"
                                displayContainerStyle={{fontSize: "16px"}}
                            />
                            {orderReceivalError && <div className="form-error">{orderReceivalError}</div>}
                        </div>
                    </div>

                    <div className='order-details-info-container'>
                        <div className='order-details-info-item'>
                            <span className='order-details-info-item-label'>
                                Дата создания:
                            </span>
                            <span className='order-details-info-item-value'>
                                {orderDetails.creation_date ? formatToReadableDate(orderDetails.creation_date) : ""}
                            </span>
                        </div>

                        <div className='order-details-info-item'>
                            <span className='order-details-info-item-label'>
                                Автор:
                            </span>
                            <span className='order-details-info-item-value'>
                                {orderDetails.author}
                            </span>
                        </div>

                        <div className='order-details-info-item'>
                            <span className='order-details-info-item-label'>
                                Количество позиции:
                            </span>
                            <span className='order-details-info-item-value'>
                                {orderDetails.total_skus?.toLocaleString('ru-RU') || 0}
                            </span>
                        </div>

                        <div className='order-details-info-item'>
                            <span className='order-details-info-item-label'>
                                Итоговая сумма:
                            </span>
                            <span className='order-details-info-item-value'>
                                {orderDetails.total_amount_kzt ? `${orderDetails.total_amount_kzt?.toLocaleString('ru-RU')} ` : "0 "}&#8376;
                            </span>
                        </div>
                    </div>

                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>
                                    <div style={{ display: 'flex', height: '100%', marginBottom: 'auto', gap: 6, }}>
                                        Наименование
                                    </div>
                                </th>
                                <th>
                                    <div style={{ display: 'flex', height: '100%', marginBottom: 'auto', gap: 6, }}>
                                        Код СКЮ
                                    </div>
                                </th>
                                <th>
                                    <div style={{ display: 'flex', height: '100%', marginBottom: 'auto', gap: 6, }}>
                                        Кол-во коробов
                                    </div>
                                </th>
                                <th>
                                    <div style={{ display: 'flex', height: '100%', marginBottom: 'auto', gap: 6, }}>
                                        Вес брутто кг
                                    </div>
                                </th>
                                <th>
                                    <div style={{ display: 'flex', height: '100%', marginBottom: 'auto', gap: 6, }}>
                                        Объем м3
                                    </div>
                                </th>
                                <th>
                                    <div style={{ display: 'flex', height: '100%', marginBottom: 'auto', gap: 6, }}>
                                        Сумма
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                orderDetails && orderDetails.items?.map((item, index) => (
                                    <tr key={item.sku_code}>
                                        <td>
                                            {item.sku_code}
                                        </td>
                                        <td>
                                            {item.sku_name}
                                        </td>
                                        <td>
                                            {item.quantity_in_mc?.toLocaleString('ru-RU')}
                                        </td>
                                        <td>
                                            {item.gross_weight_kg.toFixed(2)}
                                        </td>
                                        <td>
                                            {item.volume_cbm.toFixed(2)}
                                        </td>
                                        <td>
                                            {item.amount_kzt?.toLocaleString('ru-RU')} &#8376;
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
}

export default OrderDetails;